export default __webpack_public_path__ + "media/images/features/hida/hero-bg-sm-31705146a562ecd0ab49c521f0d9a569.png";